module.exports = __webpack_public_path__ + "static/03-db47ea8d4cc031042ae89beccd8d05c4.png";